<template>
    <b-card
    header-bg-variant="primary"
    header-class="py-2 px-3 text-white"
    body-class="p-3"
    footer-class="py-2 px-3"
    class="mx-0">
    <template #header>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 16 16"><path fill="#fff" d="M12.1.3A1.5 1.5 0 0 1 14 1.8V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9A1.5 1.5 0 0 1 1.4 3L12.1.3zM5.6 3H13V1.8a.5.5 0 0 0-.6-.5zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>
        Refinance
        <a href="javascript:void(0)" @click="$emit('remove-product-application', product_application.pcom_id)" class="position-absolute cursor-pointer" style="right: -14px; top: -7px;" v-if="is_editable">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="20" viewBox="0 0 512 512">
                <circle fill="#DF3030" cx="256" cy="256" r="256" />
                <g fill="#fff" transform="translate(148, 116) scale(0.55)">
                    <path fill="#fff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/>
                </g>
            </svg>
        </a>
    </template>

    <!--Card Body -->
    <div class="my-2">
        <p class="text-xs text-muted">Loan Amt.</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_loan_amount | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Bank (Interest Rate)</p>
        <p class="font-weight-600">{{ product_application.pcom_bank_code }} ({{ product_application.pcom_product_detail.pcp_interest_rate }}%)</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Monthly Installment</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_monthly_installment }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Tenure</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_tenure }} Years</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Bank Outstanding</p>
        <p class="font-weight-600">RM {{ product_application.pcom_product_detail.pcp_project_json.prod_ref_bank_outstanding | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Cashout Amount</p>
        <p class="font-weight-600" :class="product_application.pcom_product_detail.pcp_project_json.prod_ref_cashout_amount > 0 ? '':'text-danger'">RM {{ product_application.pcom_product_detail.pcp_project_json.prod_ref_cashout_amount | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">AF Amount (AF%)</p>
        <p class="font-weight-600" :class="product_application.pcom_product_detail.pcp_arragement_fee_amount > 0 ? '':'text-danger'">RM{{ product_application.pcom_product_detail.pcp_arragement_fee_amount | moneyFormatter }}</p>
    </div>
</b-card>
</template>
<script>

export default {
    props:['product_application', 'is_editable']
}
</script>